// Force light mode by clearing any cached dark mode preference
export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem('theme-ui-color-mode')
  }
}

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This application has been updated. ` +
      `Reload to display the latest version?`
  )

  if (answer === true) {
    window.location.reload()
  }
}
